import { variables } from "./Variables.js"
export default class Backend {

    exportToExcel(token, parent, callback) {

        console.log(token);
        fetch(`${variables.API_URL}/api/assets/${parent}/export/excel`,
            {

                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'responseType': 'arraybuffer',
                    'Authorization': 'Bearer ' + token,
                }

            }

        ).then(function (response) {
            return response.blob();
        }
        )
            .then((blob) => {
                callback(blob);
            })
            .catch((e) => { console.error(e) });
    }
}